<template>
  <div class="border-b border-slate-100 px-4 py-3 bg-white w-full overflow-hidden">
    <div class="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        v-for="lang in languages"
        :key="lang.code"
        @click="$emit('update:modelValue', lang.code)"
        class="shrink-0 px-3 py-2 rounded-xl text-sm font-semibold transition-all flex items-center gap-2 whitespace-nowrap"
        :class="[
          modelValue === lang.code
            ? 'bg-blue-500 text-white shadow-lg'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        ]"
      >
        <span class="text-lg">{{ lang.flag }}</span>
        <span>{{ lang.label }}</span>
        <span v-if="!configuredLanguages.includes(lang.code)"
              class="text-[10px] opacity-60">(vide)</span>
      </button>
    </div>

    <div v-if="modelValue" class="mt-3">
      <select
        v-model="copyFrom"
        class="w-full text-[10px] p-2 bg-slate-50 rounded-lg border border-slate-200"
        @change="handleCopyFrom"
      >
        <option value="">Copier depuis une autre langue...</option>
        <option v-for="lang in languages.filter(l => l.code !== modelValue)"
                :key="lang.code"
                :value="lang.code">
          {{ lang.flag }} {{ lang.label }}
        </option>
      </select>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits } from 'vue'
const props = defineProps({
  modelValue: String,
  languages: Array,
  configuredLanguages: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:modelValue', 'copy-from'])

const copyFrom = ref('')

const handleCopyFrom = () => {
  if (copyFrom.value) {
    emit('copy-from', { from: copyFrom.value, to: props.modelValue })
    copyFrom.value = ''
  }
}
</script>
<style scoped>
/* Masquer la scrollbar tout en gardant le défilement */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>